import { render, staticRenderFns } from "./publish-goods-show.vue?vue&type=template&id=1f60d3b4&scoped=true"
import script from "./publish-goods-show.vue?vue&type=script&lang=js"
export * from "./publish-goods-show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f60d3b4",
  null
  
)

export default component.exports